if (!customElements.get('gsp-sticky-atc')) {
  customElements.define(
    'gsp-sticky-atc',
    class GspStickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.submitButton = this.querySelector('.gsp-sticky-atc__button');
        this.priceEl = this.querySelector('.gsp-sticky-atc__price');
        this.availabilityEl = this.querySelector('.gsp-sticky-atc__availability');
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onIntersect = this.onIntersect.bind(this);
        this.onProxyClick = this.onProxyClick.bind(this);
      }

      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');

        if (window.subscribe && window.PUB_SUB_EVENTS) {
          this.unsubscribe = window.subscribe(
            window.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange
          );
        }

        const nativeSubmit = this.getNativeSubmitButton();
        if (nativeSubmit && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0 });
          this.observer.observe(nativeSubmit);
        } else {
          this.setVisible(true);
        }

        this.submitButton?.addEventListener('click', this.onProxyClick);
        this.syncDisabledFromNative();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.observer?.disconnect();
      }

      getProductInfo() {
        return this.closest('product-info') || document.querySelector('product-info');
      }

      getNativeForm() {
        return this.getProductInfo()?.querySelector('form[data-type="add-to-cart-form"]') || null;
      }

      getNativeSubmitButton() {
        return this.getProductInfo()?.querySelector('[id^="ProductSubmitButton-"]') || null;
      }

      syncDisabledFromNative() {
        const nativeButton = this.getNativeSubmitButton();
        if (nativeButton && this.submitButton) {
          this.submitButton.disabled = nativeButton.hasAttribute('disabled');
        }
      }

      onIntersect(entries) {
        const nativeButtonVisible = entries[0]?.isIntersecting;
        this.setVisible(!nativeButtonVisible);
      }

      setVisible(visible) {
        if (!this.mq.matches) {
          this.setAttribute('data-visible', 'false');
          return;
        }
        this.setAttribute('data-visible', visible ? 'true' : 'false');
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        this.syncDisabledFromNative();

        if (!variant) {
          this.setUnavailable();
          return;
        }

        if (this.priceEl) {
          const priceParts = [];
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceParts.push(`<s>${this.formatMoney(variant.compare_at_price)}</s>`);
          }
          priceParts.push(`<span>${this.formatMoney(variant.price)}</span>`);
          this.priceEl.innerHTML = priceParts.join(' ');
        }

        if (this.availabilityEl) {
          this.availabilityEl.textContent = variant.available
            ? ''
            : window.variantStrings?.soldOut || 'Sold out';
        }

        this.setAttribute('data-has-price', variant.price > 0 ? 'true' : 'false');
      }

      setUnavailable() {
        if (this.submitButton) this.submitButton.disabled = true;
        if (this.availabilityEl) {
          this.availabilityEl.textContent = window.variantStrings?.unavailable || 'Unavailable';
        }
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
          return window.Shopify.formatMoney(cents, window.moneyFormat);
        }
        return (cents / 100).toString();
      }

      onProxyClick(event) {
        event.preventDefault();
        if (this.submitButton?.disabled) return;

        const nativeForm = this.getNativeForm();
        if (!nativeForm) return;

        if (typeof nativeForm.requestSubmit === 'function') {
          nativeForm.requestSubmit();
        } else {
          nativeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    }
  );
}
